import { styled } from "styled-components";

export const PurchaseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #383838;
  color: #fff;
  border-radius: 30px;
  cursor: pointer;
  font-size: 18px;
  width: 592px;
  height: 65px;
`;
